import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";
import TodaysFollowUps from "../components/DealerManagement/Pre-sales/TodaysFollowUps";
import FollowUpRequired from "../components/DealerManagement/Pre-sales/FollowUpRequired";
import OldLeadCalling from "../components/DealerManagement/Pre-sales/OldLeadCalling";
import LeadCalling from "../components/DealerManagement/Pre-sales/LeadCalling";
import FollowUpDetails from "../components/DealerManagement/Pre-sales/TodaysFollowUps/FollowUpDetails";
import LeadCallingDetails from "../components/DealerManagement/Pre-sales/LeadCalling/LeadCallingDetails";
import FollowUpRequiredDetails from "../components/DealerManagement/Pre-sales/FollowUpRequired/FollowUpDetails";
import OldLeadCallingDetails from "../components/DealerManagement/Pre-sales/OldLeadCalling/OldLeadCallingDetails";

import AddNewLead from "../components/DealerManagement/Pre-sales/LeadAllocation/AddNewLead";
import LeadAllocationList from "../components/DealerManagement/Pre-sales/LeadAllocation";
import AdvanceSearch from "../components/DealerManagement/Pre-sales/AdvanceSearch";
import AddNewLeadPresales from "../components/DealerManagement/Pre-sales/AdvanceSearch/AddLead";
import AllowNewLead from "../components/DealerManagement/Pre-sales/AdvanceSearch/AllowNewLead";
import ActionToBeTaken from "../components/DealerManagement/Pre-sales/AdvanceSearch/ActionToBeTaken";
import Dashboard from "../components/DealerManagement/Dashboard";
import AppointmentReminder from "../components/DealerManagement/Pre-sales/AppointmentReminder";
import PresalesDashboard from "../components/DealerManagement/Pre-sales/PresalesDashboard";

const PreSalesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.PRESALEDASHBOARD}
        element={<PresalesDashboard />}
      />
       <Route
        path={ROUTES_NAVIGATION.CARDDASHBOARDPRESALES}
        element={<PresalesDashboard />}
      />
    
      <Route
        path={ROUTES_NAVIGATION.TODAYSFOLLOUPS}
        element={<TodaysFollowUps />}
      />
       <Route
        path={ROUTES_NAVIGATION.ADVANCESEARCH}
        element={<AdvanceSearch />}
      />
       <Route
        path={ROUTES_NAVIGATION.FOLLOWUPREQUIRED}
        element={<FollowUpRequired />}
      />
        <Route
        path={ROUTES_NAVIGATION.ADDLEAD}
        element={<AddNewLeadPresales />}
      />
       <Route
        path={ROUTES_NAVIGATION.ALLOWLEAD}
        element={<AllowNewLead />}
      />
      <Route
        path={ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS}
        element={<FollowUpRequiredDetails />}
      />
        <Route
        path={ROUTES_NAVIGATION.OLDLEADCALLING}
        element={<OldLeadCalling />}
      />
       <Route
        path={ROUTES_NAVIGATION.OLDLEADCALLINGDETAILS}
        element={<OldLeadCallingDetails />}
      />
       <Route
        path={ROUTES_NAVIGATION.LEADCALLING}
        element={<LeadCalling />}
      /> 
       <Route
        path={ROUTES_NAVIGATION.APPOINTMENTREMINDER}
        element={<AppointmentReminder />}
      /> 
      <Route
        path={ROUTES_NAVIGATION.LEADCALLINGDETAILS}
        element={<LeadCallingDetails />}
      /> 
       {/* <Route
        path={ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS}
        element={<FollowUpRequiredDetails />}
      />  */}
       <Route
        path={ROUTES_NAVIGATION.PRESALELEADALLOCATIONLIST}
        element={<LeadAllocationList />}
      /> 
      <Route path={ROUTES_NAVIGATION.ADDNEWLEAD} element={<AddNewLead />} />
      <Route path={ROUTES_NAVIGATION.ACTIONTOBETAKEN} element={<ActionToBeTaken />} />
    </>
  );
};

export default PreSalesRoutes;
